import React from 'react';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import TravelersList from './TravelersList/Loadable';

function RegularTravelersWidget()
{
    return (
        <CollapsibleCard
            title="Regular Travelers"
            boxClassName="tw-gap-3"
            storeId="regular_travelers_profile"
        >
            <TravelersList />
        </CollapsibleCard>
    );
}

export default RegularTravelersWidget;
